module.exports = "/img/flecha.b26271.png";